(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5376,9495],{

/***/ 77086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kz": function() { return /* binding */ googleLogout; },
/* harmony export */   "kZ": function() { return /* binding */ GoogleLogin; },
/* harmony export */   "rg": function() { return /* binding */ GoogleOAuthProvider; }
/* harmony export */ });
/* unused harmony exports hasGrantedAllScopesGoogle, hasGrantedAnyScopeGoogle, useGoogleLogin, useGoogleOAuth, useGoogleOneTapLogin */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
'use client'
;

function useLoadGsiScript(options = {}) {
    const { nonce, onScriptLoadSuccess, onScriptLoadError } = options;
    const [scriptLoadedSuccessfully, setScriptLoadedSuccessfully] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const onScriptLoadSuccessRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onScriptLoadSuccess);
    onScriptLoadSuccessRef.current = onScriptLoadSuccess;
    const onScriptLoadErrorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onScriptLoadError);
    onScriptLoadErrorRef.current = onScriptLoadError;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const scriptTag = document.createElement('script');
        scriptTag.src = 'https://accounts.google.com/gsi/client';
        scriptTag.async = true;
        scriptTag.defer = true;
        scriptTag.nonce = nonce;
        scriptTag.onload = () => {
            var _a;
            setScriptLoadedSuccessfully(true);
            (_a = onScriptLoadSuccessRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadSuccessRef);
        };
        scriptTag.onerror = () => {
            var _a;
            setScriptLoadedSuccessfully(false);
            (_a = onScriptLoadErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onScriptLoadErrorRef);
        };
        document.body.appendChild(scriptTag);
        return () => {
            document.body.removeChild(scriptTag);
        };
    }, [nonce]);
    return scriptLoadedSuccessfully;
}

const GoogleOAuthContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
function GoogleOAuthProvider({ clientId, nonce, onScriptLoadSuccess, onScriptLoadError, children, }) {
    const scriptLoadedSuccessfully = useLoadGsiScript({
        nonce,
        onScriptLoadSuccess,
        onScriptLoadError,
    });
    const contextValue = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => ({
        clientId,
        scriptLoadedSuccessfully,
    }), [clientId, scriptLoadedSuccessfully]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(GoogleOAuthContext.Provider, { value: contextValue }, children));
}
function useGoogleOAuth() {
    const context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(GoogleOAuthContext);
    if (!context) {
        throw new Error('Google OAuth components must be used within GoogleOAuthProvider');
    }
    return context;
}

function extractClientId(credentialResponse) {
    var _a;
    const clientId = (_a = credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.clientId) !== null && _a !== void 0 ? _a : credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.client_id;
    return clientId;
}

const containerHeightMap = { large: 40, medium: 32, small: 20 };
function GoogleLogin({ onSuccess, onError, useOneTap, promptMomentNotification, type = 'standard', theme = 'outline', size = 'large', text, shape, logo_alignment, width, locale, click_listener, containerProps, ...props }) {
    const btnContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const onSuccessRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully)
            return;
        (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                }
                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            ...props,
        });
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.renderButton(btnContainerRef.current, {
            type,
            theme,
            size,
            text,
            shape,
            logo_alignment,
            width,
            locale,
            click_listener,
        });
        if (useOneTap)
            (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
        return () => {
            var _a, _b, _c;
            if (useOneTap)
                (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        clientId,
        scriptLoadedSuccessfully,
        useOneTap,
        type,
        theme,
        size,
        text,
        shape,
        logo_alignment,
        width,
        locale,
    ]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { ...containerProps, ref: btnContainerRef, style: { height: containerHeightMap[size], ...containerProps === null || containerProps === void 0 ? void 0 : containerProps.style } }));
}

function googleLogout() {
    var _a, _b, _c;
    (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.disableAutoSelect();
}

/* eslint-disable import/export */
function useGoogleLogin({ flow = 'implicit', scope = '', onSuccess, onError, onNonOAuthError, overrideScope, state, ...props }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const clientRef = useRef();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const onNonOAuthErrorRef = useRef(onNonOAuthError);
    onNonOAuthErrorRef.current = onNonOAuthError;
    useEffect(() => {
        var _a, _b;
        if (!scriptLoadedSuccessfully)
            return;
        const clientMethod = flow === 'implicit' ? 'initTokenClient' : 'initCodeClient';
        const client = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2[clientMethod]({
            client_id: clientId,
            scope: overrideScope ? scope : `openid profile email ${scope}`,
            callback: (response) => {
                var _a, _b;
                if (response.error)
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef, response);
                (_b = onSuccessRef.current) === null || _b === void 0 ? void 0 : _b.call(onSuccessRef, response);
            },
            error_callback: (nonOAuthError) => {
                var _a;
                (_a = onNonOAuthErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onNonOAuthErrorRef, nonOAuthError);
            },
            state,
            ...props,
        });
        clientRef.current = client;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, scriptLoadedSuccessfully, flow, scope, state]);
    const loginImplicitFlow = useCallback((overrideConfig) => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestAccessToken(overrideConfig); }, []);
    const loginAuthCodeFlow = useCallback(() => { var _a; return (_a = clientRef.current) === null || _a === void 0 ? void 0 : _a.requestCode(); }, []);
    return flow === 'implicit' ? loginImplicitFlow : loginAuthCodeFlow;
}

function useGoogleOneTapLogin({ onSuccess, onError, promptMomentNotification, cancel_on_tap_outside, prompt_parent_id, state_cookie_domain, hosted_domain, use_fedcm_for_prompt = false, use_fedcm_for_button = false, disabled, auto_select, }) {
    const { clientId, scriptLoadedSuccessfully } = useGoogleOAuth();
    const onSuccessRef = useRef(onSuccess);
    onSuccessRef.current = onSuccess;
    const onErrorRef = useRef(onError);
    onErrorRef.current = onError;
    const promptMomentNotificationRef = useRef(promptMomentNotification);
    promptMomentNotificationRef.current = promptMomentNotification;
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!scriptLoadedSuccessfully)
            return;
        if (disabled) {
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
            return;
        }
        (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.google) === null || _d === void 0 ? void 0 : _d.accounts) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.initialize({
            client_id: clientId,
            callback: (credentialResponse) => {
                var _a;
                if (!(credentialResponse === null || credentialResponse === void 0 ? void 0 : credentialResponse.credential)) {
                    return (_a = onErrorRef.current) === null || _a === void 0 ? void 0 : _a.call(onErrorRef);
                }
                const { credential, select_by } = credentialResponse;
                onSuccessRef.current({
                    credential,
                    clientId: extractClientId(credentialResponse),
                    select_by,
                });
            },
            hosted_domain,
            cancel_on_tap_outside,
            prompt_parent_id,
            state_cookie_domain,
            use_fedcm_for_prompt,
            use_fedcm_for_button,
            auto_select,
        });
        (_j = (_h = (_g = window === null || window === void 0 ? void 0 : window.google) === null || _g === void 0 ? void 0 : _g.accounts) === null || _h === void 0 ? void 0 : _h.id) === null || _j === void 0 ? void 0 : _j.prompt(promptMomentNotificationRef.current);
        return () => {
            var _a, _b, _c;
            (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.id) === null || _c === void 0 ? void 0 : _c.cancel();
        };
    }, [
        clientId,
        scriptLoadedSuccessfully,
        cancel_on_tap_outside,
        prompt_parent_id,
        state_cookie_domain,
        hosted_domain,
        use_fedcm_for_prompt,
        use_fedcm_for_button,
        disabled,
        auto_select,
    ]);
}

/**
 * Checks if the user granted all the specified scope or scopes
 * @returns True if all the scopes are granted
 */
function hasGrantedAllScopesGoogle(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google))
        return false;
    return (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAllScopes(tokenResponse, firstScope, ...restScopes)) || false);
}

/**
 * Checks if the user granted any of the specified scope or scopes.
 * @returns True if any of the scopes are granted
 */
function hasGrantedAnyScopeGoogle(tokenResponse, firstScope, ...restScopes) {
    var _a, _b, _c;
    if (!(window === null || window === void 0 ? void 0 : window.google))
        return false;
    return (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.accounts) === null || _b === void 0 ? void 0 : _b.oauth2) === null || _c === void 0 ? void 0 : _c.hasGrantedAnyScope(tokenResponse, firstScope, ...restScopes)) || false);
}




/***/ }),

/***/ 62611:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[slug]",
      function () {
        return __webpack_require__(54001);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BlogCard_BlogCard; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/BlogSection/BlogCard/BlogCard.module.scss
var BlogCard_module = __webpack_require__(53206);
var BlogCard_module_default = /*#__PURE__*/__webpack_require__.n(BlogCard_module);
// EXTERNAL MODULE: ./components/BlogSection/BlogImage/BlogImage.tsx
var BlogImage = __webpack_require__(64196);
;// CONCATENATED MODULE: ./components/BlogSection/BlogCard/BlogCard.tsx





var BlogCard = function(param) {
    var post = param.post, _noBorderRadius = param.noBorderRadius, noBorderRadius = _noBorderRadius === void 0 ? false : _noBorderRadius;
    // Function to check if body has actual content (not just empty HTML tags)
    var hasActualContent = function(htmlContent) {
        if (!htmlContent) return false;
        // Remove all HTML tags using regex (works in both client and server)
        var textContent = htmlContent.replace(/<[^>]*>/g, "");
        // Decode HTML entities
        var decodedContent = textContent.replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        // Remove all whitespace and check if there's actual content
        var cleanedContent = decodedContent.trim().replace(/\s+/g, " ");
        return cleanedContent.length > 0;
    };
    var hasBody = hasActualContent(post.body);
    var isClickable = hasBody && post.slug;
    var handleClick = function() {
        if (isClickable) {
            window.location.href = "/news/".concat(post.slug);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((BlogCard_module_default()).card, " ").concat(noBorderRadius ? (BlogCard_module_default()).noBorderRadius : "", " ").concat(isClickable ? (BlogCard_module_default()).clickable : (BlogCard_module_default()).notClickable),
        onClick: handleClick,
        role: isClickable ? "button" : undefined,
        tabIndex: isClickable ? 0 : undefined,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((BlogCard_module_default()).cardImage, " ").concat(noBorderRadius ? (BlogCard_module_default()).noBorderRadius : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BlogImage/* default */.Z, {
                    src: post.image,
                    alt: post.title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    isClickable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardTags,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (BlogCard_module_default()).tag,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.category
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-xs",
                                as: "span",
                                className: (BlogCard_module_default()).readTime,
                                style: {
                                    color: "#D6BBFB"
                                },
                                children: post.readTime
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardHeader,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                variant: "text-lg",
                                as: "h3",
                                color: "grayDark-50",
                                className: (BlogCard_module_default()).cardTitle,
                                children: post.title
                            }),
                            isClickable && /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                className: (BlogCard_module_default()).linkIcon,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M4 12L12 4M4 4H12V12",
                                    stroke: "currentColor",
                                    strokeWidth: "1.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                        variant: "text-md",
                        as: "p",
                        color: "grayDark-400",
                        className: (BlogCard_module_default()).cardDescription,
                        children: post.description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BlogCard_module_default()).cardAuthor,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (BlogCard_module_default()).authorAvatar,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: post.author.avatar,
                                    alt: post.author.name,
                                    width: 40,
                                    height: 40,
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (BlogCard_module_default()).authorInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "primary",
                                        weight: "medium",
                                        children: post.author.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                        variant: "text-sm",
                                        as: "span",
                                        color: "grayDark-400",
                                        children: post.author.date
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var BlogCard_BlogCard = (BlogCard);

;// CONCATENATED MODULE: ./components/BlogSection/BlogCard/index.ts



/***/ }),

/***/ 64196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57135);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15767);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);




// The blog carousel renders several clones of each slide for its infinite-loop
// effect (react-slick), so the same image src mounts multiple times. Without
// this cache, each mounted instance below would independently fetch() and
// blob the same remote image, multiplying network requests by the clone count.
var blobUrlCache = new Map();
var getCachedObjectUrl = function(src) {
    var entry = blobUrlCache.get(src);
    if (!entry) {
        entry = fetch(src, {
            method: "GET",
            credentials: "omit"
        }).then(function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(response) {
                var blob, finalBlob, urlLower, mimeType;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!response.ok) throw new Error("Failed to fetch image: ".concat(response.status));
                            return [
                                4,
                                response.blob()
                            ];
                        case 1:
                            blob = _state.sent();
                            finalBlob = blob;
                            if (!blob.type || blob.type === "application/octet-stream") {
                                urlLower = src.toLowerCase();
                                mimeType = "image/jpeg";
                                if (urlLower.includes(".png")) mimeType = "image/png";
                                else if (urlLower.includes(".gif")) mimeType = "image/gif";
                                else if (urlLower.includes(".webp")) mimeType = "image/webp";
                                finalBlob = new Blob([
                                    blob
                                ], {
                                    type: mimeType
                                });
                            }
                            return [
                                2,
                                URL.createObjectURL(finalBlob)
                            ];
                    }
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }());
        blobUrlCache.set(src, entry);
        entry.catch(function() {
            return blobUrlCache.delete(src);
        });
    }
    return entry;
};
var BlogImage = function(param) {
    var src = param.src, alt = param.alt, _className = param.className, className = _className === void 0 ? "" : _className, _fallbackSrc = param.fallbackSrc, fallbackSrc = _fallbackSrc === void 0 ? "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80" : _fallbackSrc;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(src), imageSrc = ref[0], setImageSrc = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hasError = ref1[0], setHasError = ref1[1];
    var triedOriginalRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    // Try to load image as blob if it's from media/view API. The blob/object URL
    // itself is cached by src in getCachedObjectUrl above, so carousel clones of
    // the same slide share one network fetch instead of issuing one each.
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setHasError(false);
        triedOriginalRef.current = false;
        if (src && src.includes("/media/view?")) {
            var cancelled = false;
            getCachedObjectUrl(src).then(function(url) {
                if (!cancelled) setImageSrc(url);
            }).catch(function(error) {
                console.warn("Failed to load image as blob, using direct URL:", error);
                if (!cancelled) setImageSrc(src);
            });
            return function() {
                cancelled = true;
            };
        }
        setImageSrc(src);
    }, [
        src
    ]);
    var handleError = function() {
        if (hasError) return;
        // The shared object URL failed to render - try the original src once before
        // giving up on the remote image entirely.
        if (!triedOriginalRef.current && src && src !== imageSrc) {
            triedOriginalRef.current = true;
            setImageSrc(src);
            return;
        }
        console.warn("Image failed to load:", imageSrc);
        setHasError(true);
        setImageSrc(fallbackSrc);
    };
    var handleLoad = function() {
        setHasError(false);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        src: imageSrc,
        alt: alt,
        className: className,
        onError: handleError,
        onLoad: handleLoad,
        loading: "lazy"
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogImage);


/***/ }),

/***/ 96424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageWrapper_PageWrapper; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./components/Header/Header.tsx + 1 modules
var Header = __webpack_require__(15304);
// EXTERNAL MODULE: ./components/Footer/Footer.tsx
var Footer = __webpack_require__(83767);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
// EXTERNAL MODULE: ./components/PageWrapper/PageWrapper.module.scss
var PageWrapper_module = __webpack_require__(70930);
var PageWrapper_module_default = /*#__PURE__*/__webpack_require__.n(PageWrapper_module);
;// CONCATENATED MODULE: ./components/PageWrapper/PageWrapper.tsx






var PageWrapper = function(param) {
    var dateText = param.dateText, titleText = param.titleText, introText = param.introText, _headerContainerClass = param.headerContainerClass, headerContainerClass = _headerContainerClass === void 0 ? "" : _headerContainerClass, _headerSectionClass = param.headerSectionClass, headerSectionClass = _headerSectionClass === void 0 ? "" : _headerSectionClass, _contentContainerClass = param.contentContainerClass, contentContainerClass = _contentContainerClass === void 0 ? "" : _contentContainerClass, children = param.children, aboutData = param.aboutData, additionalHeaderContent = param.additionalHeaderContent, additionalContent = param.additionalContent;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (PageWrapper_module_default()).pageWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((PageWrapper_module_default()).headerContainer, " ").concat((PageWrapper_module_default()).pattern, " ").concat(headerContainerClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: "".concat((PageWrapper_module_default()).headerSection, " ").concat(headerSectionClass),
                        children: [
                            !!dateText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).dateContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-md",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).dateText,
                                    children: dateText
                                })
                            }),
                            !!titleText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).titleContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "display-lg",
                                    as: "h1",
                                    color: "primary",
                                    weight: "bold",
                                    className: (PageWrapper_module_default()).mainTitle,
                                    children: titleText
                                })
                            }),
                            !!introText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (PageWrapper_module_default()).introContainer,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                    variant: "text-xl",
                                    color: "secondary",
                                    weight: "normal",
                                    className: (PageWrapper_module_default()).introText,
                                    children: introText
                                })
                            }),
                            additionalHeaderContent
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "".concat((PageWrapper_module_default()).contentContainer, " ").concat(contentContainerClass),
                    children: children
                }),
                additionalContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {
                    aboutData: aboutData
                })
            ]
        })
    });
};
/* harmony default export */ var PageWrapper_PageWrapper = (PageWrapper);

;// CONCATENATED MODULE: ./components/PageWrapper/index.ts



/***/ }),

/***/ 55306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "cv": function() { return /* reexport */ StructuredData_ArticleSchema; },
  "vd": function() { return /* reexport */ StructuredData_BreadcrumbSchema; },
  "od": function() { return /* reexport */ StructuredData_OrganizationSchema; },
  "zC": function() { return /* reexport */ StructuredData_ProductSchema; },
  "uA": function() { return /* reexport */ StructuredData_SoftwareApplicationSchema; }
});

// UNUSED EXPORTS: StructuredData

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/head.js
var head = __webpack_require__(73917);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/StructuredData/StructuredData.tsx


var StructuredData = function(param) {
    var data = param.data;
    var jsonLd = Array.isArray(data) ? data : [
        data
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: jsonLd.map(function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // JSON.stringify doesn't escape "</script>" - a field containing
                // that literal string could break out of the script tag and
                // inject arbitrary markup/script into the page.
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(item).replace(/</g, "\\u003c")
                }
            }, index);
        })
    });
};
/* harmony default export */ var StructuredData_StructuredData = (StructuredData);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(72006);
;// CONCATENATED MODULE: ./components/StructuredData/OrganizationSchema.tsx
/* provided dependency */ var process = __webpack_require__(82985);



var OrganizationSchema = function(param) {
    var _name = param.name, name = _name === void 0 ? "EPEN Ltd." : _name, _url = param.url, url = _url === void 0 ? "https://vxfx.io" : _url, _logo = param.logo, logo = _logo === void 0 ? "https://vxfx.io/epenfav.webp" : _logo, _description = param.description, description = _description === void 0 ? "EPEN Ltd. is a software company that develops video plugin development frameworks for Adobe Premiere and DaVinci Resolve." : _description, email = param.email, phone = param.phone, address = param.address, _sameAs = param.sameAs, sameAs = _sameAs === void 0 ? [] : _sameAs;
    var siteUrl = process.env.SITE_URL || "https://vxfx.io";
    var organizationSchema = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Organization",
        name: name,
        url: url || siteUrl,
        logo: logo || "".concat(siteUrl, "/epenfav.webp"),
        description: description
    }, email && {
        email: email
    }, phone && {
        telephone: phone
    }, address && {
        address: (0,_object_spread/* default */.Z)({
            "@type": "PostalAddress"
        }, address.streetAddress && {
            streetAddress: address.streetAddress
        }, address.addressLocality && {
            addressLocality: address.addressLocality
        }, address.addressRegion && {
            addressRegion: address.addressRegion
        }, address.postalCode && {
            postalCode: address.postalCode
        }, address.addressCountry && {
            addressCountry: address.addressCountry
        })
    }, sameAs.length > 0 && {
        sameAs: sameAs
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: organizationSchema
    });
};
/* harmony default export */ var StructuredData_OrganizationSchema = (OrganizationSchema);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(4405);
;// CONCATENATED MODULE: ./components/StructuredData/ProductSchema.tsx
/* provided dependency */ var ProductSchema_process = __webpack_require__(82985);




var ProductSchema = function(param) {
    var name = param.name, description = param.description, image = param.image, url = param.url, _brand = param.brand, brand = _brand === void 0 ? "EPEN Ltd." : _brand, sku = param.sku, offers = param.offers, aggregateRating = param.aggregateRating;
    var siteUrl = ProductSchema_process.env.SITE_URL || "https://vxfx.io";
    var productUrl = url || "".concat(siteUrl, "/video-plugin-framework/").concat(name.toLowerCase().replace(/\s+/g, "-"));
    var productImage = image || "".concat(siteUrl, "/epenfav.webp");
    var productSchema = (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Product",
        name: name
    }, description && {
        description: description
    }), {
        image: Array.isArray(image) ? image : [
            productImage
        ],
        url: productUrl,
        brand: {
            "@type": "Brand",
            name: brand
        }
    }), sku && {
        sku: sku
    }, offers && {
        offers: (0,_object_spread/* default */.Z)({
            "@type": "Offer"
        }, offers.price && {
            price: offers.price
        }, offers.priceCurrency && {
            priceCurrency: offers.priceCurrency
        }, offers.availability && {
            availability: "https://schema.org/".concat(offers.availability)
        }, offers.url && {
            url: offers.url
        })
    }, aggregateRating && {
        aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: aggregateRating.ratingValue,
            reviewCount: aggregateRating.reviewCount
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: productSchema
    });
};
/* harmony default export */ var StructuredData_ProductSchema = (ProductSchema);

;// CONCATENATED MODULE: ./components/StructuredData/ArticleSchema.tsx
/* provided dependency */ var ArticleSchema_process = __webpack_require__(82985);




var ArticleSchema = function(param) {
    var headline = param.headline, description = param.description, image = param.image, datePublished = param.datePublished, dateModified = param.dateModified, author = param.author, _publisher = param.publisher, publisher = _publisher === void 0 ? {
        name: "EPEN Ltd.",
        logo: "https://vxfx.io/epenfav.webp"
    } : _publisher, url = param.url;
    var siteUrl = ArticleSchema_process.env.SITE_URL || "https://vxfx.io";
    var articleUrl = url || "".concat(siteUrl, "/news/").concat(headline.toLowerCase().replace(/\s+/g, "-"));
    var articleImage = image || "".concat(siteUrl, "/epenfav.webp");
    var articleSchema = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "Article",
        headline: headline
    }, description && {
        description: description
    }), {
        image: Array.isArray(image) ? image : [
            articleImage
        ],
        datePublished: datePublished
    }), dateModified && {
        dateModified: dateModified
    }, author && {
        author: (0,_object_spread/* default */.Z)({
            "@type": "Person",
            name: author.name
        }, author.url && {
            url: author.url
        })
    }), {
        publisher: {
            "@type": "Organization",
            name: publisher.name,
            logo: {
                "@type": "ImageObject",
                url: publisher.logo || "".concat(siteUrl, "/epenfav.webp")
            }
        },
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": articleUrl
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: articleSchema
    });
};
/* harmony default export */ var StructuredData_ArticleSchema = (ArticleSchema);

;// CONCATENATED MODULE: ./components/StructuredData/BreadcrumbSchema.tsx
/* provided dependency */ var BreadcrumbSchema_process = __webpack_require__(82985);


var BreadcrumbSchema = function(param) {
    var items = param.items;
    var siteUrl = BreadcrumbSchema_process.env.SITE_URL || "https://vxfx.io";
    var breadcrumbSchema = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map(function(item, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                name: item.name,
                item: item.url.startsWith("http") ? item.url : "".concat(siteUrl).concat(item.url)
            };
        })
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: breadcrumbSchema
    });
};
/* harmony default export */ var StructuredData_BreadcrumbSchema = (BreadcrumbSchema);

;// CONCATENATED MODULE: ./components/StructuredData/SoftwareApplicationSchema.tsx
/* provided dependency */ var SoftwareApplicationSchema_process = __webpack_require__(82985);




var SoftwareApplicationSchema = function(param) {
    var _name = param.name, name = _name === void 0 ? "VxFx" : _name, _description = param.description, description = _description === void 0 ? "Universal video plugin framework supporting Windows, macOS, and Linux. GPU-accelerated with CUDA, OpenCL, Metal, and DirectX." : _description, image = param.image, _operatingSystem = param.operatingSystem, operatingSystem = _operatingSystem === void 0 ? "Windows, macOS, Linux" : _operatingSystem, _applicationCategory = param.applicationCategory, applicationCategory = _applicationCategory === void 0 ? "MultimediaApplication" : _applicationCategory, offers = param.offers;
    var siteUrl = SoftwareApplicationSchema_process.env.SITE_URL || "https://vxfx.io";
    var schema = (0,_object_spread/* default */.Z)({
        "@context": "https://schema.org",
        "@type": "SoftwareApplication",
        name: name,
        description: description,
        image: image || "".concat(siteUrl, "/epenfav.webp"),
        operatingSystem: operatingSystem,
        applicationCategory: applicationCategory,
        url: siteUrl
    }, offers && {
        offers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            "@type": "Offer"
        }, offers.price && {
            price: offers.price
        }), {
            priceCurrency: offers.priceCurrency || "USD"
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredData_StructuredData, {
        data: schema
    });
};
/* harmony default export */ var StructuredData_SoftwareApplicationSchema = (SoftwareApplicationSchema);

;// CONCATENATED MODULE: ./components/StructuredData/index.ts








/***/ }),

/***/ 54001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(4405);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96376);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50959);
/* harmony import */ var _components_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39181);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32033);
/* harmony import */ var _components_BlogSection_BlogCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21876);
/* harmony import */ var _components_BlogSection_BlogImage_BlogImage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64196);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51156);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96410);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38337);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(23362);
/* harmony import */ var _news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _components_PageWrapper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96424);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(95656);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38743);
/* harmony import */ var _utils_sanitizeHtml__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42770);
/* harmony import */ var _components_StructuredData__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55306);
/* harmony import */ var _data_keywords__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(83075);
/* provided dependency */ var process = __webpack_require__(82985);



















var BlogDetailPage = function(param) {
    var post = param.post, aboutData = param.aboutData, relatedPosts = param.relatedPosts;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), extractedHeadings = ref9[0], setExtractedHeadings = ref9[1];
    // Extract headings from blog body content
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(post === null || post === void 0 ? void 0 : post.body)) return;
        try {
            var parser = new DOMParser();
            var doc = parser.parseFromString(post.body, "text/html");
            var headings = doc.querySelectorAll("h1, h2, h3, h4, h5, h6");
            var headingsArray = Array.from(headings).map(function(heading, index) {
                var text = heading.textContent || "";
                var id = "heading-".concat(index);
                return {
                    id: id,
                    label: text
                };
            });
            setExtractedHeadings(headingsArray);
            // Add IDs to headings in the rendered DOM
            var addIdsToHeadings = function() {
                setTimeout(function() {
                    var blogContent = document.querySelector(".".concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().bodyContent)));
                    if (blogContent) {
                        var headingElements = blogContent.querySelectorAll("h1, h2, h3, h4, h5, h6");
                        headingElements.forEach(function(element, index) {
                            var ref;
                            element.setAttribute("id", ((ref = headingsArray[index]) === null || ref === void 0 ? void 0 : ref.id) || "heading-".concat(index));
                        });
                    }
                }, 300);
            };
            addIdsToHeadings();
        } catch (error) {
            console.error("Error extracting headings:", error);
        }
    }, [
        post === null || post === void 0 ? void 0 : post.body
    ]);
    // Helper function to format date
    var formatDate = function(dateString) {
        var date = new Date(dateString);
        var day = date.getDate();
        var monthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec", 
        ];
        var month = monthNames[date.getMonth()];
        var year = date.getFullYear();
        return "".concat(day, " ").concat(month, " ").concat(year);
    };
    // Format related posts
    var formatBlogPosts = function(apiPosts) {
        return apiPosts.map(function(post) {
            var ref, ref1, ref2;
            return {
                id: post._id,
                image: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .formatBlogImageUrl */ .a)((ref = post.coverImage) === null || ref === void 0 ? void 0 : ref.url),
                category: ((ref1 = post.categories) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || "General",
                readTime: post.readingTime ? "".concat(post.readingTime, " min read") : "5 min read",
                title: post.title,
                description: post.summary || "Read more about this blog post.",
                author: {
                    name: "EPEN Team",
                    avatar: "/chat/chat-admin-avatar.png",
                    date: post.publishedAt ? formatDate(post.publishedAt) : formatDate(new Date().toISOString())
                },
                slug: post.slug,
                body: post.body
            };
        });
    };
    var formattedRelatedPosts = formatBlogPosts(relatedPosts);
    var showCarousel = formattedRelatedPosts.length > 2;
    // Carousel settings
    var carouselSettings = {
        dots: false,
        infinite: showCarousel,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false
                }
            }, 
        ]
    };
    // Get author info (default to EPEN Team if not available)
    var authorName = ((ref = post.author) === null || ref === void 0 ? void 0 : ref.name) || "EPEN Team";
    var authorAvatar = ((ref1 = post.author) === null || ref1 === void 0 ? void 0 : ref1.avatar) || "/chat/chat-admin-avatar.png";
    var publishedDate = formatDate(post.publishedAt);
    var readTime = post.readingTime || "5";
    // Share functions
    var getCurrentUrl = function() {
        if (true) {
            return window.location.href;
        }
        return "";
    };
    var handleShareFacebook = function() {
        var url = encodeURIComponent(getCurrentUrl());
        var title = encodeURIComponent(post.title);
        var windowFeatures = "width=600,height=400,menubar=no,toolbar=no,resizable=yes,scrollbars=yes";
        window.open("https://www.facebook.com/sharer/sharer.php?u=".concat(url, "&quote=").concat(title), "Facebook Share", windowFeatures);
    };
    var handleShareTwitter = function() {
        var url = encodeURIComponent(getCurrentUrl());
        var title = encodeURIComponent(post.title);
        var windowFeatures = "width=600,height=400,menubar=no,toolbar=no,resizable=yes,scrollbars=yes";
        window.open("https://twitter.com/intent/tweet?url=".concat(url, "&text=").concat(title), "Twitter Share", windowFeatures);
    };
    var handleShareLinkedIn = function() {
        var url = encodeURIComponent(getCurrentUrl());
        var windowFeatures = "width=600,height=400,menubar=no,toolbar=no,resizable=yes,scrollbars=yes";
        window.open("https://www.linkedin.com/sharing/share-offsite/?url=".concat(url), "LinkedIn Share", windowFeatures);
    };
    var handleCopyLink = function() {
        var url = getCurrentUrl();
        navigator.clipboard.writeText(url).then(function() {
            alert("Link copied to clipboard!");
        }).catch(function(err) {
            console.error("Failed to copy link:", err);
        });
    };
    var handleTocClick = function(e, id) {
        e.preventDefault();
        var element = document.getElementById(id);
        if (element) {
            var elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = elementPosition - 100; // 100px offset
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
    var siteUrl = process.env.SITE_URL || "https://vxfx.io";
    var blogImage = ((ref2 = post.coverImage) === null || ref2 === void 0 ? void 0 : ref2.url) ? (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .formatBlogImageUrl */ .a)(post.coverImage.url) : "".concat(siteUrl, "/epenfav.webp");
    // Create optimized description with call-to-action
    var blogDescription = post.summary || post.title || "";
    if (blogDescription && blogDescription.length > 120) {
        var truncated = blogDescription.substring(0, 120).trim();
        var lastSpace = truncated.lastIndexOf(" ");
        blogDescription = lastSpace > 100 ? "".concat(truncated.substring(0, lastSpace), "... Read more!") : "".concat(truncated, "... Read the full article!");
    } else if (blogDescription && blogDescription.length < 100) {
        blogDescription = "".concat(blogDescription, " Discover insights on video plugin development and software solutions.");
    }
    // Get optimized keywords for the article
    var articleTags = ((ref3 = post.categories) === null || ref3 === void 0 ? void 0 : ref3.map(function(cat) {
        return cat.name;
    })) || [];
    var articleKeywords = (0,_data_keywords__WEBPACK_IMPORTED_MODULE_13__/* .getArticleKeywords */ .E4)(post.title, articleTags);
    var keywordsString = (0,_data_keywords__WEBPACK_IMPORTED_MODULE_13__/* .formatKeywords */ .zh)(articleKeywords);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                title: post.title,
                description: blogDescription,
                image: blogImage,
                type: "article",
                publishedTime: post.publishedAt,
                modifiedTime: post.publishedAt,
                author: (ref4 = post.author) === null || ref4 === void 0 ? void 0 : ref4.name,
                keywords: keywordsString
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StructuredData__WEBPACK_IMPORTED_MODULE_12__/* .ArticleSchema */ .cv, {
                headline: post.title,
                description: post.summary || post.title,
                image: blogImage,
                datePublished: post.publishedAt,
                dateModified: post.publishedAt,
                author: ((ref5 = post.author) === null || ref5 === void 0 ? void 0 : ref5.name) ? {
                    name: post.author.name
                } : undefined,
                url: "".concat(siteUrl, "/news/").concat(router.query.slug)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_StructuredData__WEBPACK_IMPORTED_MODULE_12__/* .BreadcrumbSchema */ .vd, {
                items: [
                    {
                        name: "Home",
                        url: "/"
                    },
                    {
                        name: "News",
                        url: "/news"
                    },
                    {
                        name: post.title,
                        url: "/news/".concat(router.query.slug)
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageWrapper__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                aboutData: aboutData,
                title: post.title,
                titleText: "",
                headerSectionClass: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().headerSectionClass),
                headerContainerClass: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().headerContainerClass),
                contentContainerClass: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contentContainerClass),
                additionalHeaderContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroSection),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroContainer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroContent),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroBadge),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroBadgeTag),
                                                    children: ((ref6 = post.categories) === null || ref6 === void 0 ? void 0 : (ref7 = ref6[0]) === null || ref7 === void 0 ? void 0 : ref7.name) || "General"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroReadTime),
                                                    children: [
                                                        readTime,
                                                        " min read"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                            variant: "display-md",
                                            as: "h1",
                                            color: "primary",
                                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroTitle),
                                            children: post.title
                                        }),
                                        post.summary && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                            variant: "text-xl",
                                            as: "p",
                                            color: "grayDark-400",
                                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroDescription),
                                            children: post.summary
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroAuthor),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroAuthorAvatar),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: authorAvatar,
                                                        alt: "".concat(authorName, " - Blog Post Author")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroAuthorDetails),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                            variant: "text-sm",
                                                            as: "span",
                                                            color: "primary",
                                                            weight: "medium",
                                                            children: authorName
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                            variant: "text-sm",
                                                            as: "span",
                                                            color: "grayDark-400",
                                                            children: [
                                                                "Published ",
                                                                publishedDate
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                ((ref8 = post.coverImage) === null || ref8 === void 0 ? void 0 : ref8.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroImageContainer),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogSection_BlogImage_BlogImage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                            src: (0,_utils__WEBPACK_IMPORTED_MODULE_15__/* .formatBlogImageUrl */ .a)(post.coverImage.url),
                                            alt: post.coverImage.title || "".concat(post.title, " - Blog Post Cover Image")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().heroArrow),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                width: "298",
                                                height: "148",
                                                viewBox: "0 0 298 148",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M297.557 67.7877C297.739 66.4189 296.776 65.1622 295.408 64.9807C294.039 64.7992 292.782 65.7617 292.601 67.1304L295.079 67.459L297.557 67.7877ZM159.257 144.668L159.735 142.214L159.734 142.214L159.257 144.668ZM43.1254 119.413L41.9594 121.625L41.9602 121.625L43.1254 119.413ZM9.051 3.73587C8.05889 2.77559 6.4762 2.80141 5.51593 3.7935C4.55566 4.7856 4.58147 6.3683 5.57358 7.32857L7.31229 5.53222L9.051 3.73587ZM-0.000462801 46.8841C-0.0652392 48.2633 1.0003 49.4339 2.37949 49.4987C3.7587 49.5635 4.92926 48.4979 4.99404 47.1187L2.49679 47.0014L-0.000462801 46.8841ZM38.6801 8.35C40.0366 8.60754 41.345 7.71668 41.6026 6.36018C41.8601 5.00371 40.9692 3.6953 39.6128 3.43775L39.1464 5.89386L38.6801 8.35ZM295.079 67.459C292.601 67.1304 292.601 67.1301 292.601 67.1302C292.601 67.1306 292.601 67.1309 292.6 67.1317C292.6 67.1333 292.6 67.136 292.599 67.1399C292.598 67.1476 292.597 67.1599 292.594 67.1767C292.59 67.2103 292.583 67.2618 292.573 67.3307C292.554 67.4684 292.524 67.6754 292.484 67.9469C292.404 68.49 292.281 69.2908 292.112 70.3109C291.775 72.3515 291.255 75.2667 290.525 78.7492C289.063 85.7246 286.77 94.927 283.445 103.918C280.106 112.949 275.797 121.563 270.395 127.521C265.048 133.419 258.859 136.5 251.484 135.216L251.055 137.678L250.626 140.141C260.216 141.812 268.012 137.593 274.1 130.88C280.133 124.225 284.71 114.915 288.135 105.652C291.575 96.3498 293.927 86.8892 295.418 79.7749C296.165 76.2125 296.698 73.2262 297.045 71.1266C297.219 70.0765 297.346 69.2474 297.43 68.6782C297.473 68.3936 297.504 68.1738 297.525 68.0238C297.535 67.9488 297.543 67.8912 297.549 67.8516C297.551 67.8319 297.553 67.8166 297.555 67.8059C297.556 67.8006 297.556 67.7964 297.557 67.7933C297.557 67.7918 297.557 67.7904 297.557 67.7896C297.557 67.7885 297.557 67.7877 295.079 67.459ZM251.055 137.678L251.484 135.216C244.712 134.036 240.981 127.955 238.939 117.155C236.921 106.479 236.829 92.6285 236.202 78.0324C235.583 63.6198 234.438 48.5805 230.152 36.1735C225.831 23.6651 218.197 13.5238 204.509 9.519L203.807 11.9184L203.105 14.3178C214.745 17.7235 221.44 26.2686 225.426 37.8061C229.447 49.445 230.586 63.8111 231.206 78.247C231.819 92.4995 231.92 106.941 234.026 118.083C236.109 129.101 240.435 138.366 250.626 140.141L251.055 137.678ZM203.807 11.9184L204.509 9.519C190.51 5.42323 177.917 12.1616 167.882 23.6525C157.84 35.1505 149.909 51.837 144.907 69.0762C139.903 86.3198 137.745 104.406 139.481 118.808C141.19 132.983 146.898 144.81 158.78 147.122L159.257 144.668L159.734 142.214C151.313 140.576 146.106 131.982 144.445 118.21C142.813 104.665 144.832 87.2784 149.709 70.4696C154.588 53.6562 162.243 37.7102 171.648 26.9415C181.059 16.1657 191.775 11.0031 203.105 14.3178L203.807 11.9184ZM159.257 144.668L158.779 147.122C164.468 148.229 169.557 147.188 173.941 144.46C178.265 141.769 181.769 137.524 184.564 132.411C190.141 122.209 193.209 107.977 194.142 93.4875C195.078 78.9638 193.887 63.8912 190.726 51.8839C189.147 45.8847 187.048 40.5416 184.397 36.3953C181.759 32.27 178.415 29.089 174.268 27.8959L173.577 30.2984L172.886 32.7009C175.413 33.428 177.895 35.5082 180.184 39.0889C182.46 42.6486 184.39 47.4563 185.891 53.1566C188.89 64.5484 190.06 79.0697 189.152 93.1661C188.242 107.296 185.262 120.711 180.177 130.012C177.642 134.65 174.662 138.122 171.299 140.215C167.995 142.271 164.193 143.082 159.735 142.214L159.257 144.668ZM173.577 30.2984L174.268 27.8959C166.686 25.7143 159.054 27.8381 152 31.9748C144.947 36.1108 138.184 42.4179 132.118 49.1573C126.036 55.9156 120.556 63.2228 116.092 69.4544C111.554 75.7881 108.208 80.8008 106.172 83.318L108.116 84.8899L110.06 86.4618C112.213 83.8002 115.805 78.4395 120.156 72.3661C124.58 66.1906 129.936 59.0571 135.835 52.5021C141.751 45.9282 148.115 40.0493 154.529 36.2879C160.943 32.5272 167.12 31.042 172.886 32.7009L173.577 30.2984ZM108.116 84.8899L106.172 83.318C101.677 88.8773 94.12 101.358 83.2813 110.69C77.9347 115.293 71.99 118.92 65.528 120.406C59.1318 121.878 52.0605 121.294 44.2905 117.201L43.1254 119.413L41.9602 121.625C50.7663 126.264 59.0601 127.025 66.6491 125.279C74.1724 123.548 80.8332 119.395 86.5435 114.479C97.8186 104.772 106.181 91.2599 110.06 86.4618L108.116 84.8899ZM43.1254 119.413L44.2913 117.202C36.8242 113.265 32.6945 106.553 30.3116 97.803C27.9055 88.9678 27.367 78.3785 26.8936 67.0488C26.4253 55.8398 26.0204 43.9553 23.7517 32.9993C21.4755 22.0068 17.2789 11.6997 9.051 3.73587L7.31229 5.53222L5.57358 7.32857C12.8199 14.3424 16.6941 23.575 18.8556 34.0132C21.0246 44.4878 21.4245 55.925 21.898 67.2575C22.3664 78.4693 22.9069 89.6415 25.4873 99.1168C28.0908 108.677 32.855 116.824 41.9594 121.625L43.1254 119.413ZM2.49679 47.0014C4.99404 47.1187 4.99406 47.1186 4.99406 47.1183C4.99408 47.118 4.99408 47.1176 4.99411 47.117C4.99417 47.1159 4.99425 47.1142 4.99437 47.1119C4.99457 47.1073 4.99489 47.1005 4.99533 47.0914C4.99618 47.0732 4.99746 47.0461 4.99914 47.0102C5.00253 46.9385 5.00755 46.8319 5.01414 46.6926C5.02729 46.4141 5.04665 46.0049 5.07151 45.4823C5.12121 44.4372 5.1928 42.9386 5.28041 41.1252C5.4556 37.4983 5.69477 32.6127 5.95064 27.5774C6.46573 17.4415 7.04046 6.87573 7.29768 4.56674L4.81303 4.28995L2.3284 4.01317C2.04949 6.51697 1.46612 17.3069 0.957104 27.3236C0.700925 32.3645 0.461564 37.2545 0.286226 40.8839C0.198563 42.6988 0.12689 44.1986 0.0771464 45.2448C0.0522723 45.768 0.0328931 46.1777 0.0197069 46.4567C0.0131145 46.5962 0.00806965 46.703 0.00469446 46.775C0.00299499 46.8109 0.00170791 46.8382 0.000850053 46.8565C0.000409262 46.8656 8.73441e-05 46.8725 -0.000120242 46.8772C-0.000225234 46.8795 -0.000324774 46.8812 -0.000370202 46.8824C-0.000405381 46.8829 -0.000416066 46.8834 -0.000422389 46.8837C-0.000454842 46.884 -0.000462801 46.8841 2.49679 47.0014ZM4.81303 4.28995L7.29768 4.56674C7.23984 5.08587 6.94619 5.39066 6.83041 5.48153C6.7583 5.53809 6.81249 5.47345 7.14366 5.37665C7.80149 5.18435 8.90483 5.0456 10.4618 5.0095C13.5241 4.93848 17.6571 5.27182 21.8885 5.76997C26.0937 6.26502 30.2933 6.91005 33.4486 7.43283C35.0244 7.69391 36.3355 7.92382 37.2515 8.08823C37.7094 8.17042 38.0683 8.2362 38.3119 8.28126C38.4337 8.30381 38.5266 8.32114 38.5887 8.33278C38.6197 8.33861 38.643 8.343 38.6584 8.34589C38.666 8.34733 38.6717 8.3484 38.6753 8.34909C38.6771 8.34942 38.6785 8.34968 38.6792 8.34983C38.6796 8.34991 38.6799 8.34996 38.6801 8.34998C38.6802 8.35001 38.6801 8.35 39.1464 5.89386C39.6128 3.43775 39.6124 3.43769 39.612 3.43762C39.6117 3.43754 39.6112 3.43744 39.6105 3.43734C39.6093 3.43709 39.6075 3.43676 39.6052 3.43632C39.6007 3.43546 39.5941 3.43422 39.5855 3.4326C39.5683 3.42935 39.5432 3.42461 39.5102 3.41843C39.4443 3.40608 39.3474 3.38799 39.2216 3.3647C38.9698 3.31813 38.6021 3.25074 38.1348 3.16687C37.2004 2.99917 35.867 2.76536 34.2659 2.50009C31.0674 1.97013 26.7842 1.31178 22.4731 0.80426C18.1882 0.299825 13.7713 -0.0686033 10.3459 0.0108472C8.65892 0.0499681 7.03387 0.199511 5.74078 0.577495C5.09652 0.765831 4.36959 1.05683 3.74355 1.54816C3.07378 2.07377 2.45326 2.89244 2.3284 4.01317L4.81303 4.28995Z",
                                                    fill: "white"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().blogDetailPage),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mainContentWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().contentArea),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tableOfContents),
                                        children: [
                                            extractedHeadings.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-sm",
                                                        as: "h3",
                                                        weight: "medium",
                                                        color: "grayDark-300",
                                                        children: "Table of contents"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                        children: extractedHeadings.map(function(item) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "#".concat(item.id),
                                                                    onClick: function(e) {
                                                                        return handleTocClick(e, item.id);
                                                                    },
                                                                    children: item.label
                                                                })
                                                            }, item.id);
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().socialShare),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        title: "Share on Facebook",
                                                        onClick: handleShareFacebook,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 24 24",
                                                            fill: "currentColor",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        title: "Share on Twitter",
                                                        onClick: handleShareTwitter,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 24 24",
                                                            fill: "currentColor",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                d: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        title: "Share on LinkedIn",
                                                        onClick: handleShareLinkedIn,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 24 24",
                                                            fill: "currentColor",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    d: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                    cx: "4",
                                                                    cy: "4",
                                                                    r: "2"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                        title: "Copy link",
                                                        onClick: handleCopyLink,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "20",
                                                            height: "20",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    d: "M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    d: "M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().blogContent),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().bodyContent),
                                                dangerouslySetInnerHTML: {
                                                    __html: (0,_utils_sanitizeHtml__WEBPACK_IMPORTED_MODULE_16__/* .sanitizeRichText */ .b)(post.body)
                                                }
                                            }),
                                            post.categories && post.categories.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tags),
                                                children: post.categories.map(function(category, index) {
                                                    var tagClass = (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tag);
                                                    // Apply different colors based on category name or index
                                                    if (category.name.toLowerCase().includes("design")) {
                                                        tagClass = "".concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tag), " ").concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tagPurple));
                                                    } else if (category.name.toLowerCase().includes("research") || index % 2 === 1) {
                                                        tagClass = "".concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tag), " ").concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tagBlue));
                                                    } else {
                                                        tagClass = "".concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tag), " ").concat((_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().tagPurple));
                                                    }
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: tagClass,
                                                        children: category.name
                                                    }, category.slug);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mobileTocAndShare),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mobileTableOfContents),
                                                        children: extractedHeadings.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                                    variant: "text-sm",
                                                                    as: "h3",
                                                                    weight: "medium",
                                                                    color: "grayDark-300",
                                                                    children: "Table of contents"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                    children: extractedHeadings.map(function(item) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                                href: "#".concat(item.id),
                                                                                onClick: function(e) {
                                                                                    return handleTocClick(e, item.id);
                                                                                },
                                                                                children: item.label
                                                                            })
                                                                        }, item.id);
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mobileSocialShare),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                title: "Share on Facebook",
                                                                onClick: handleShareFacebook,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "currentColor",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                        d: "M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                title: "Share on Twitter",
                                                                onClick: handleShareTwitter,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "currentColor",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                        d: "M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                title: "Share on LinkedIn",
                                                                onClick: handleShareLinkedIn,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "currentColor",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                            d: "M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                                            cx: "4",
                                                                            cy: "4",
                                                                            r: "2"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                title: "Copy link",
                                                                onClick: handleCopyLink,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                                    width: "20",
                                                                    height: "20",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                            d: "M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                            d: "M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogSection),
                            children: formattedRelatedPosts && formattedRelatedPosts.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    showCarousel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogHeaderWrapper),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogHeaderLeft),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-sm",
                                                        as: "span",
                                                        color: "grayDark-400",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().latestLabel),
                                                        children: "Latest"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "display-md",
                                                        as: "h2",
                                                        color: "primary",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogTitle),
                                                        children: "From the blog"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-md",
                                                        as: "p",
                                                        color: "grayDark-400",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogDescription),
                                                        children: "The latest industry news, interviews, technologies, and resources."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                                        variant: "primary",
                                                        size: "md",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().viewAllButtonDesktop),
                                                        onClick: function() {
                                                            return window.location.href = "/news";
                                                        },
                                                        children: "View all posts"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogHeaderRight),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogCarouselWrapper),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, carouselSettings), {
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogCarousel),
                                                        children: formattedRelatedPosts.map(function(relatedPost) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogSection_BlogCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                                post: relatedPost,
                                                                noBorderRadius: true
                                                            }, relatedPost.id);
                                                        })
                                                    }))
                                                })
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogSimpleLayout),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogHeaderLeft),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-sm",
                                                        as: "span",
                                                        color: "grayDark-400",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().latestLabel),
                                                        children: "Latest"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "display-md",
                                                        as: "h2",
                                                        color: "primary",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogTitle),
                                                        children: "From the blog"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                        variant: "text-md",
                                                        as: "p",
                                                        color: "grayDark-400",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogDescription),
                                                        children: "The latest industry news, interviews, technologies, and resources."
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                                        variant: "primary",
                                                        size: "md",
                                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().viewAllButtonDesktop),
                                                        onClick: function() {
                                                            return window.location.href = "/news";
                                                        },
                                                        children: "View all posts"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogSimpleLayoutCards),
                                                children: formattedRelatedPosts.map(function(relatedPost) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogSection_BlogCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        post: relatedPost
                                                    }, relatedPost.id);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogMobileContainer),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                variant: "text-sm",
                                                as: "span",
                                                color: "grayDark-400",
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mobileLatestLabel),
                                                children: "Latest"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                variant: "display-md",
                                                as: "h2",
                                                color: "primary",
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mobileFromBlogTitle),
                                                children: "From the blog"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Typography */ .ZT, {
                                                variant: "text-md",
                                                as: "p",
                                                color: "grayDark-400",
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().mobileFromBlogDescription),
                                                children: "The latest industry news, interviews, technologies, and resources."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().fromBlogMobilePosts),
                                                children: formattedRelatedPosts.slice(0, showCarousel ? 2 : formattedRelatedPosts.length).map(function(relatedPost) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_BlogSection_BlogCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                        post: relatedPost
                                                    }, relatedPost.id);
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                                variant: "primary",
                                                size: "md",
                                                className: (_news_detail_module_scss__WEBPACK_IMPORTED_MODULE_14___default().viewAllButtonMobile),
                                                onClick: function() {
                                                    return window.location.href = "/news";
                                                },
                                                children: "View all posts"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (BlogDetailPage);


/***/ }),

/***/ 95656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ formatBlogImageUrl; },
/* harmony export */   "cx": function() { return /* binding */ cx; }
/* harmony export */ });
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4814);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5466);


function cx() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_0__/* .twMerge */ .m6)((0,clsx__WEBPACK_IMPORTED_MODULE_1__/* .clsx */ .W)(inputs));
}
/**
 * Formats image URL for blog posts
 * If the URL is an S3 URL, it wraps it in the media view API endpoint
 * @param imageUrl - The image URL from the API
 * @returns Formatted image URL
 */ function formatBlogImageUrl(imageUrl) {
    if (!imageUrl) {
        return "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80";
    }
    // If it's already a media view URL, return as is
    if (imageUrl.includes("/media/view?")) {
        return imageUrl;
    }
    // If it's an S3 URL, wrap it in the media view API
    if (imageUrl.includes("vxfx-io.s3.eu-central-1.amazonaws.com") || imageUrl.includes("s3.eu-central-1.amazonaws.com")) {
        var encodedUrl = encodeURIComponent(imageUrl);
        return "https://api.vxfx.io/media/view?url=".concat(encodedUrl);
    }
    // If it's a direct API file path (like /1733110794800_xxx.webp or https://api.vxfx.io/1733110794800_xxx.webp)
    // These need to be wrapped in /media/view endpoint for Next.js Image to work
    if (imageUrl.startsWith("http") && imageUrl.includes("api.vxfx.io") && !imageUrl.includes("/media/view") || imageUrl.startsWith("/") && imageUrl.match(/\/\d+_[a-f0-9]+\.(jpg|jpeg|png|gif|webp|svg|avif)$/i)) {
        // If it's a relative path, make it absolute
        var absoluteUrl = imageUrl.startsWith("http") ? imageUrl : "https://api.vxfx.io".concat(imageUrl);
        var encodedUrl1 = encodeURIComponent(absoluteUrl);
        return "https://api.vxfx.io/media/view?url=".concat(encodedUrl1);
    }
    // For other URLs (like unsplash), return as is
    return imageUrl;
}


/***/ }),

/***/ 53206:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"BlogCard_card__Rtf5J","noBorderRadius":"BlogCard_noBorderRadius__Hkfyp","clickable":"BlogCard_clickable__V77H8","notClickable":"BlogCard_notClickable__OehVq","cardImage":"BlogCard_cardImage__iMhQW","cardTags":"BlogCard_cardTags__dPSo0","tag":"BlogCard_tag__6nCjW","readTime":"BlogCard_readTime__JCiRX","cardHeader":"BlogCard_cardHeader__7VsMl","cardTitle":"BlogCard_cardTitle__xMqRe","cardDescription":"BlogCard_cardDescription__xZi_p","linkIcon":"BlogCard_linkIcon__Y9iO7","cardAuthor":"BlogCard_cardAuthor__ye5Ff","authorAvatar":"BlogCard_authorAvatar__xqcXF","authorInfo":"BlogCard_authorInfo__dqOja"};

/***/ }),

/***/ 70930:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageWrapper_pageWrapper__MAYBo","pattern":"PageWrapper_pattern__3xQmd","headerContainer":"PageWrapper_headerContainer__DAIQD","headerSection":"PageWrapper_headerSection__BJHBX","dateContainer":"PageWrapper_dateContainer__OCDfk","dateText":"PageWrapper_dateText__ErZHL","titleContainer":"PageWrapper_titleContainer__V5tyY","mainTitle":"PageWrapper_mainTitle__yIEnc","introText":"PageWrapper_introText__ZUDXH","contentContainer":"PageWrapper_contentContainer__0fKHq"};

/***/ }),

/***/ 23362:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainerClass":"news-detail_headerContainerClass__4oLdB","headerSectionClass":"news-detail_headerSectionClass__7M090","contentContainerClass":"news-detail_contentContainerClass__SQWbJ","heroSection":"news-detail_heroSection__ALf6r","heroContainer":"news-detail_heroContainer__Z23p5","heroContent":"news-detail_heroContent__czyA8","heroBadge":"news-detail_heroBadge__2C1wc","heroBadgeTag":"news-detail_heroBadgeTag__1DQtz","heroReadTime":"news-detail_heroReadTime__I9jqa","heroTitle":"news-detail_heroTitle__5KzV2","heroDescription":"news-detail_heroDescription__yfAgv","heroAuthor":"news-detail_heroAuthor__POV97","heroAuthorAvatar":"news-detail_heroAuthorAvatar__9x_fU","heroAuthorDetails":"news-detail_heroAuthorDetails__BRUj9","heroImageContainer":"news-detail_heroImageContainer__36Qop","heroArrow":"news-detail_heroArrow__jISPw","mainContentWrapper":"news-detail_mainContentWrapper__QtC8v","fromBlogSection":"news-detail_fromBlogSection__A3lFD","fromBlogHeader":"news-detail_fromBlogHeader__GjxTN","fromBlogHeaderWrapper":"news-detail_fromBlogHeaderWrapper__F041p","fromBlogSimpleLayout":"news-detail_fromBlogSimpleLayout__E_PZ1","fromBlogSimpleLayoutCards":"news-detail_fromBlogSimpleLayoutCards__Zjlyf","fromBlogHeaderLeft":"news-detail_fromBlogHeaderLeft__58B69","fromBlogHeaderRight":"news-detail_fromBlogHeaderRight__w2RQq","fromBlogHeaderContent":"news-detail_fromBlogHeaderContent__eeU4q","latestLabel":"news-detail_latestLabel__si_2z","fromBlogTitle":"news-detail_fromBlogTitle__jZdRP","fromBlogDescription":"news-detail_fromBlogDescription__BkshV","viewAllButtonDesktop":"news-detail_viewAllButtonDesktop__yfg6h","viewAllButtonMobile":"news-detail_viewAllButtonMobile__phC9X","fromBlogCarouselWrapper":"news-detail_fromBlogCarouselWrapper__Har0E","fromBlogCarousel":"news-detail_fromBlogCarousel__8QKp7","fromBlogMobileContainer":"news-detail_fromBlogMobileContainer__q1MQC","mobileLatestLabel":"news-detail_mobileLatestLabel__V8ko9","mobileFromBlogTitle":"news-detail_mobileFromBlogTitle__bu2E6","mobileFromBlogDescription":"news-detail_mobileFromBlogDescription__SgsPk","fromBlogMobilePosts":"news-detail_fromBlogMobilePosts__X9C17","contentArea":"news-detail_contentArea__a75K6","tableOfContents":"news-detail_tableOfContents__8BboV","socialShare":"news-detail_socialShare__v7y9p","blogContent":"news-detail_blogContent__FoOVA","bodyContent":"news-detail_bodyContent__OAw_d","tags":"news-detail_tags__bA9NG","tag":"news-detail_tag__iCeW0","tagPurple":"news-detail_tagPurple__5N6N0","tagBlue":"news-detail_tagBlue__JPuS8","mobileTocAndShare":"news-detail_mobileTocAndShare__eKcOZ","mobileTableOfContents":"news-detail_mobileTableOfContents__t36w1","mobileSocialShare":"news-detail_mobileSocialShare__Fh5Ql"};

/***/ }),

/***/ 97508:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 57135:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 31922:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; },
/* harmony export */   "y": function() { return /* binding */ SkeletonTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
'use client';


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, customHighlightBackground, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    if (typeof customHighlightBackground === 'string')
        style['--custom-highlight-background'] = customHighlightBackground;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3977,6538,6607,8030,5119,9201,1166,2033,5304,6309,9774,2888,179], function() { return __webpack_exec__(62611); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);